

const AGENCIES_URI = '/api/admin/agencies';
const AGENCY_URI = '/api/admin/agency';
const AGENCIES_QUERY_URI = '/api/admin/agencies-query';


export const AgenciesApi = {
    async findAgencies(query) {
        const response = await axios.get(`${AGENCIES_QUERY_URI}?query=`+query);
        console.log(response);
        return response.data;
    },
    async getAllAgencies() {
        const response = await axios.get(`${AGENCIES_URI}`);
        console.log(response);
        return response.data;
    },
    async createAgency(objet) {
        const response = await axios.post(`${AGENCY_URI}`, objet);
        console.log(response);
        return response.data;
    },
    async deleteAgency(objet) {
        const response = await axios.delete(`${AGENCY_URI}`, { data: objet });
        console.log(response);
        return response.data;
    }
};
